export function callback(componentName = null, context = null) {
    let items = [];

    context = context || document;

    if (componentName) {
        items = context.querySelectorAll(`[x-data][data-component-name="${componentName}"]`);
    } else {
        items = context.querySelectorAll('[x-data]');
    }

    return Array.from(items).map(item => item.__x).filter(item => !!item);
};

export default ($el) => {
    if ($el.$instances) {
        return $el.$instances;
    }

    return $el.$instances = callback;
};